'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var requiredIf = require('react-required-if');

var Textarea = function (_React$Component) {
  _inherits(Textarea, _React$Component);

  function Textarea() {
    var _temp, _this, _ret;

    _classCallCheck(this, Textarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleChange = function (e) {
      if (_this.props.onChange) {
        _this.props.onChange(e.target.value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Textarea.prototype.render = function render() {
    var className = 'cf-textarea';

    if (this.props.disabled) className += ' cf-textarea--disabled';
    if (this.props.readOnly) className += ' cf-textarea--readonly';

    return React.createElement('textarea', {
      className: className,
      name: this.props.name,
      value: this.props.value,
      disabled: this.props.disabled,
      readOnly: this.props.readOnly,
      onChange: this.handleChange,
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur });
  };

  return Textarea;
}(React.Component);

Textarea.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: requiredIf(PropTypes.func, function (props) {
    return !props.disabled && !props.readOnly;
  }),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};


module.exports = Textarea;